// extracted by mini-css-extract-plugin
export default {"item":"PartnersItemMobile_item__+IZ1f"};